/**
 * Module dependencies.
 */

import { color } from 'styles/utils/colors';
import { css } from '@emotion/react';
import { ifProp } from 'styled-tools';
import styled from '@emotion/styled';
/**
 * Export `Wrapper` styled component.
 */

export const Wrapper = styled.div`
  margin-top: 120px;
  display: flex;
  gap: 40px;
  flex-wrap: wrap;
  justify-content: center;

  @media (max-width: 768px) {
    margin-top: 40px;
    gap: 16px;
    margin-left: -16px;
    margin-right: -16px;
    margin-bottom: -24px;
    padding: 0 32px 24px;
  }
`;

/**
 * Export `Category` styled component.
 */

export const Category = styled.div<{
  active: boolean;
}>`
  color: ${color('primary500')};
  font-size: 16px;
  border: 1px solid ${color('primary300')};
  padding: 8px 16px;
  border-radius: 30px;
  font-family: 'Inter', sans-serif;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  cursor: pointer;
  white-space: nowrap;

  ${ifProp(
    'active',
    (props) => css`
      color: ${color('white')(props)};
      background-color: ${color('primary500')(props)};
      border: 1px solid ${color('primary500')(props)};
    `,
  )}

  &:hover {
    text-decoration: none;
    color: ${color('white')};
    background-color: ${color('primary500')};
    border: 1px solid ${color('primary500')};
  }
`;
